<template>
  <div class="page-comp-lower-customer">
    <jw-spin :loading="loading" :style="{ width: '100%' }">
      <jw-card class="qf-card-big" :bordered="false">
        <jw-space direction="vertical" fill>
          <xl-table v-on="tPropsEvent" v-bind="tProps" :columns="columns">
            <!-- 客户名称插槽--详情 -->
            <template #customerName="{ record }">
              <jw-link @click="toClientDetails(record)" v-if="record.customerName">{{ record.customerName }}</jw-link>
              <template v-else>-</template>
            </template>
            <!-- 负责人插槽 -->
            <template #chargePerson="{ record }">
              <xl-avatar v-if="record.chargePerson" :avatar="{ name: record?.chargePersonName || '', url: record?.chargePersonAvatar, id: record?.chargePerson }" :size="22" />
              <template v-else>-</template>
            </template>
            <!-- 关联工商信息 qccId-->
            <template #qccId="{ record }">
              <div class="qccId-tr">
                <span class="qccId-status">{{ record.qccId ? $t('是') : $t('否') }}</span>
                <jw-tooltip :content="$t('tips.customerIsRequired')" position="rt" mini>
                  <icon-exclamation-circle-fill size="20" style="color: orange; cursor: pointer" v-if="!record.qccId" @click="correlation(record)" />
                </jw-tooltip>
              </div>
            </template>
            <!-- 客户级别 -->
            <template #customer_level="{ record }">
              <jw-tag bordered color="cyan" v-if="record?.custom?.customer_level === 'A类'">
                {{ record.custom.customer_level }}
              </jw-tag>
              <jw-tag bordered color="arcoblue" v-else-if="record?.custom?.customer_level === 'B类'">
                {{ record.custom.customer_level }}
              </jw-tag>
              <jw-tag bordered color="pinkpurple" v-else-if="record?.custom?.customer_level === 'C类'">
                {{ record.custom.customer_level }}
              </jw-tag>
              <template v-else>-</template>
            </template>
            <!-- 联系人所在部门-->
            <template #department="{ record }">
              <span>{{ record.department ? record.department : '-' }}</span>
            </template>
            <!-- 职位-->
            <template #jobTitle="{ record }">
              <span>{{ record.jobTitle ? record.jobTitle : '-' }}</span>
            </template>
            <!-- kdm-->
            <template #kdm="{ record }">
              <span>{{ record.kdm == '0' ? $t('是') : record.kdm == '1' ? $t('否') : record.kdm == '2' ? $t('老板委托调研人') : record.kdm == '3' ? $t('暂不确定') : '-' }}</span>
            </template>
            <!-- 跟进建议 插槽 -->
            <template #intentionality="{ record }">
              <xl-dot :title="record?.custom.intentionality" :color="colors[3]" v-if="record?.custom?.intentionality === '待处理'">
                {{ record.custom.intentionality }}
              </xl-dot>
              <xl-dot :title="record?.custom.intentionality" :color="colors[0]" v-else-if="record?.custom?.intentionality === '建议转化'">
                {{ record.custom.intentionality }}
              </xl-dot>
              <xl-dot :title="record?.custom.intentionality" :color="colors[1]" v-else-if="record?.custom?.intentionality === '建议无效'">
                {{ record.custom.intentionality }}
              </xl-dot>
              <xl-dot :title="record?.custom.intentionality" :color="colors[2]" v-else-if="record?.custom?.intentionality === '待定'">
                {{ record.custom.intentionality }}
              </xl-dot>
              <xl-dot :title="record?.custom.intentionality" :color="colors[4]" v-else-if="record?.custom?.intentionality">
                {{ record.custom.intentionality }}
              </xl-dot>
              <template v-else>-</template>
            </template>
            <!-- 成交状态 -->
            <template #isDealt="{ record }">
              <jw-tag v-if="record.isDealt || record.isDealt === 0" :color="record.isDealt == 1 ? 'green' : 'pinkpurple'" size="small">{{ $t(clientState?.[record.isDealt]) }}</jw-tag>
              <template v-else> - </template>
            </template>
            <!-- 跟进人插槽 -->
            <template #followUser="{ record }">
              <xl-avatar v-if="record.followUser" :avatar="{ name: record?.followUserName || '', url: record?.followUserAvatar, id: record?.followUser }" :size="22" />
              <template v-else> - </template>
            </template>
            <!-- 创建人插槽 -->
            <template #createUser="{ record }">
              <xl-avatar v-if="record.createUser" :avatar="{ name: record?.createUserName || '', url: record?.createUserAvatar, id: record?.createUser }" :size="22" />
              <template v-else>-</template>
            </template>
            <!-- 最后更新人插槽 -->
            <template #updateUser="{ record }">
              <xl-avatar v-if="record.updateUser" :avatar="{ name: record?.updateUserName || '', url: record?.updateUserAvatar, id: record?.updateUser }" :size="22" />
              <template v-else>-</template>
            </template>
            <!-- 官网链接 -->
            <template #customer_web_url="{ record }">
              <jw-link v-if="record?.custom?.customer_web_url" :href="record?.custom?.customer_web_url" target="_blank">{{ $t('查看') }}</jw-link>
              <template v-else>-</template>
            </template>
            <!-- 重点客户插槽 -->
            <template #important="{ record }">
              <jw-tag v-if="record?.important" color="magenta" size="small">{{ $t('重点') }}</jw-tag>
              <template v-else>-</template>
            </template>
            <!-- 最后跟进内容 -->
            <template #lastFollowContent="{ record }">
              <template v-if="record?.lastFollowContent">{{ tools.stripMarkdown(record?.lastFollowContent) }}</template>
              <template v-else>-</template>
            </template>
          </xl-table>
        </jw-space>
      </jw-card>
    </jw-spin>
    <!-- 客户详情 -->
    <component :is="clientDetailDrawer" v-if="isComponentShow" ref="lowerClientRef"></component>
  </div>
</template>

<script>
import { reactive, toRefs, ref, inject, provide, computed, nextTick, onMounted } from 'vue';
import useLoading from '@/hooks/loading';
import { clientService } from '@/api/';
import useXlTable from '@/hooks/xl-table';
import { tools } from '@/utils/tools';
// import { Message } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
// import dayjs from 'dayjs';
import { checkboxOptions, clientState } from '@/utils/const';
// import { useRouter } from 'vue-router';
import ClientDetailDrawer from '@/components/fh-detail/index.vue'; //客户详情抽屉
import useFields from '@/hooks/fields';
import { useI18n } from 'vue-i18n';

export default {
  name: 'LowerCustomer',
  setup() {
    const data = reactive({
      clientDetailDrawer: ClientDetailDrawer,
      fieldList: [], //获取字段列表所有数据
      columns: [],
      colors: ['#37b41a', 'var(--color-text-2)', 'gold', 'orange', 'gray'], //跟进建议颜色
      id: inject('detailParams').id, //客户ID、
      type: 2, //类型1-线索 2-客户 3-商机 4-产品
      followUserId: '', //跟进人id
      record: [],
      exportLoading: false,
      lowerId: '', //下级客户Id
      isComponentShow: false
    });
    const { t } = useI18n();
    const { loading, setLoading } = useLoading(false); //loading
    const searchObj = ref({});
    const selectContacts = ref(); //拨打电话ref
    const { userInfo } = useUserStore(); //用户信息
    // const router = useRouter();
    // 表格表头数据字段
    const { enableList, getFields, getFieldLabel } = useFields({ id: 2 });
    const lowerClientRef = ref(); //客户详情弹窗

    const { tProps, tPropsEvent, setTProps, setLoadListParams, loadTList } = useXlTable(clientService.getCustomerList.bind(clientService));
    // 设置额外的props
    setTProps({
      stickyHeader: 60
    });

    // 获取所有字段值,生成表格头部
    const getField = async () => {
      const params = {
        id: data.type
      };
      await getFields(params);
      console.log('获取所有字段值：生成表格头部', enableList);
      data.fieldList = enableList.value?.filter((v) => v.fieldKey !== 'parentCustomerId' && v.fieldKey !== 'qccId');
      console.log(165, data.fieldList);
      data.columns = getColumns();
      init();
    };

    // 从所有字段中获取表格头部标题
    const getColumns = () => {
      const list = [];
      const fieldList = data.fieldList?.filter((i) => ['calendarId', 'callId', 'recordId'].indexOf(i.fieldKey) == -1);
      fieldList?.forEach((item) => {
        const k = item.fieldKey; //字段标识
        // console.log(31700, item.type, item.fieldKey);
        const render = ({ record }) => {
          let fieldKey = record[k];
          if (item.type === 2) {
            fieldKey = record?.['custom']?.[k];
          }
          if (fieldKey || fieldKey === 0) {
            if (item.fieldType === 9) {
              if (fieldKey && fieldKey !== '{}') {
                return Object.values(JSON.parse(fieldKey))?.join('/');
              } else {
                return '-';
              }
            } else if (item.fieldType === 6) {
              if (fieldKey instanceof Array) {
                return fieldKey?.map((v) => v.name)?.join(',');
              } else {
                return '-';
              }
            } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
              return getFieldLabel(fieldKey, item.fieldExt, item.fieldType);
            } else if (item.fieldType === 12) {
              return fieldKey?.label || '-';
            } else {
              return fieldKey?.label ?? fieldKey?.value ?? fieldKey ?? '-';
            }
          } else {
            return '-';
          }
        };

        const colType = {
          title: item.fieldName,
          dataIndex: k,
          ellipsis: true,
          tooltip: true
        };
        if (item.type === 1) {
          colType.colType = t('基础字段');
        }
        if (item.type === 2) {
          colType.dataIndex = `${k}Custom`;
        }
        const width = item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30;
        if (k === 'customerName') {
          list.push({ ...colType, fixed: 'left', slotName: 'customerName', width: 200 });
        } else if (k === 'customer_level' || k === 'important' || k === 'lastFollowContent ' || k === 'followUser' || k === 'createUser' || k === 'updateUser' || k === 'customer_web_url' || k === 'chargePerson' || k === 'qccId' || k === 'intentionality ' || k === 'department' || k === 'jobTitle' || k === 'kdm' || k === 'isDealt') {
          list.push({ ...colType, slotName: k, width: 160 });
        } else if (k === 'industry' || k === 'city') {
          //行业和城市
          list.push({ ...colType, width: 220, render });
        } else if (k === 'mobile') {
          //手机号
          list.push({ ...colType, width: 140, render });
        } else {
          list.push({ ...colType, width, render });
        }
      });
      return list;
    };

    //点击公司名称--客户详情
    const toClientDetails = (record) => {
      data.isComponentShow = true;
      console.log(240, record);
      data.lowerId = record?.id;
      nextTick(() => {
        console.log(238, record, lowerClientRef.value);
        lowerClientRef.value?.openDialog();
      });
      // router.push({ name: 'client-index-detail', params: { id: record.id } });
    };
    // 商机详情中--详细信息页签客户字段跳转详情时修改defaultParams改为globalParams
    provide('globalParams', {
      id: computed(() => data.lowerId),
      entity: computed(() => data.type)
    });
    // 获取数据
    const init = () => {
      setLoadListParams({
        conditions: [
          {
            fieldKey: 'parentCustomerId',
            fieldValue: data.id,
            type: 0,
            fieldType: 12
          }
        ]
      });
      loadTList();
    };
    onMounted(() => {
      getField();
    });
    return {
      loading,
      setLoading,
      searchObj,
      tProps,
      tPropsEvent,
      useXlTable,
      getField,
      getColumns,
      toClientDetails,
      tools,
      userInfo,
      loadTList,
      lowerClientRef, // 客户详情ref
      selectContacts, //选择联系人
      checkboxOptions,
      clientState,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
